<ul
  class="m-0 p-0 candidate-contact"
  [class.vertical-layout]="verticalLayout"
>
  <li
    *ngIf="includeResumeButton && !hideResumeDownloadButton"
    (click)="$event?.stopPropagation()"
    class="resume-box"
  >
    <mojo-candidate-resume-preview-link [candidate]="candidate">
    </mojo-candidate-resume-preview-link>
  </li>

  <li
    *ngIf="includeContactButtons && candidate?.mail"
    (click)="$event?.stopPropagation()"
    [class.candidate-card]="candidateCard"
    class="email-box"
  >
    <mat-icon class="small-icon mr-1">mail_outline</mat-icon>
    <a
      [title]="candidate?.visibleMail"
      class="text-truncate email"
      data-cy="candidate-contact-email"
      href="mailto:{{ candidate?.mail }}"
    >{{ candidate?.visibleMail }}</a>
  </li>

  <li
    (click)="$event?.stopPropagation()"
    [class.candidate-card]="candidateCard"
    *ngIf="includeContactButtons && candidate?.mobile"
    class="phone-box"
    data-cy="candidate-contact-phone"
  >
    <mat-icon class="small-icon mr-1">phone</mat-icon>
    <a
      class="btn btn-link"
      href="tel:{{ candidate?.mobile }}"
    >
      <span>{{candidate?.mobile | commonPhoneFormat}}</span>
    </a>
  </li>

  <mojo-candidate-extra-info
    *ngIf="showQA && !!candidate?.id"
    class="qa-box"
    (click)="$event?.stopPropagation()"
    [class.candidate-card]="candidateCard"
    [candidateId]="candidate?.id"
  ></mojo-candidate-extra-info>
</ul>
